export default {"src":"/_next/static/media/Ollie_Site_Icons_working_final_Recyclablitiy.29415503.svg","height":70,"width":69,"blurWidth":0,"blurHeight":0};